//import axios from 'axios';
import localforage from 'localforage'
import memoryDriver from 'localforage-memoryStorageDriver'
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import {interceptorResponse, interceptorError} from '@/helpers/interceptorResponse';
import { LOCAL_STORAGE_ACCESS_TOKEN } from '@/helpers/local_storage_constants';

class API {
  async configure(){
    const DB_NAME = "infohidro-forecasts";
    // await localforage.defineDriver(memoryDriver);

    const forageStore = localforage.createInstance({
      driver: [
        localforage.INDEXEDDB,
        localforage.LOCALSTORAGE,
        memoryDriver._driver
      ],
      name: DB_NAME
    });

    const cache = setupCache({
      // {Number} Maximum time for storing each request in milliseconds,
      // defaults to 15 minutes when using `setup()`.
      maxAge: 60 * 60 * 1000, // 1 hour
      // {Number} Maximum number of cached request (last in, first out queue system),
      // defaults to `false` for no limit. *Cannot be overridden per request*
      limit: 50,
      store: forageStore,
      // {Function|Boolean} Determine if stale cache should be read when a network error occurs.      
      // readOnError: (error) => {
      //   // Attempt reading stale cache data when response status is either 4xx or 5xx
      //   return error.response.status >= 400 && error.response.status < 600
      // },
      // {Boolean} Clear cached item when it is stale.
      // clearOnStale: true,
      // Deactivate `clearOnStale` option so that we can actually read stale cache data
      // By default axios-cache-adapter clears stale cache data automatically, this would conflict with activating the readOnError option, so the clearOnStale option should be set to false.
      // clearOnStale: false,
      // {Function|Boolean} Print out debug log to console.
      // debug: true,
    });
    
    
    const api = axios.create({
      adapter: cache.adapter,
      baseURL: `${process.env.VUE_APP_API_BASE_FORECASTS}`,
      timeout: 60000
    });

    api.interceptors.request.use(this.authInterceptor);

    api.interceptors.response.use(
      interceptorResponse,
      interceptorError
    );

    return api;
  }

  authInterceptor (config) {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN);
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  }
}

export default API;